import { render } from "./Team_manager_adviser_m.vue?vue&type=template&id=1c48f885&scoped=true"
import script from "./Team_manager_adviser_m.vue?vue&type=script&lang=js"
export * from "./Team_manager_adviser_m.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1c48f885"

export default script